import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { RegistrationSuccess } from '../components/auth/RegistrationSuccess';

interface LocationState {
  firstName?: string;
  email?: string;
  registeredAt?: string;
}

const RegistrationSuccessPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Extract registration data from navigation state
  const state = location.state as LocationState | null;

  // If no registration data is available, redirect to home
  React.useEffect(() => {
    if (!state?.email) {
      // Redirect to home if accessed directly without registration data
      navigate('/', { replace: true });
    }
  }, [state, navigate]);

  // Don't render anything if redirecting
  if (!state?.email) {
    return null;
  }

  const handleGoHome = () => {
    navigate('/', { replace: true });
  };

  return (
    <RegistrationSuccess
      firstName={state.firstName}
      email={state.email}
      registeredAt={state.registeredAt}
      onGoHome={handleGoHome}
    />
  );
};

export { RegistrationSuccessPage };